// src/components/assistant/MessageActions.tsx
//
// Acciones bajo cada respuesta del agente: Copiar y Regenerar. En pantallas con
// puntero aparecen al pasar/enfocar el mensaje (siempre visibles en el último); en
// táctil, siempre visibles (ver .o-msg-actions en messageContent.css).
//
// «Convertir en tarea/nota» NO está: el dashboard no tiene un endpoint genérico de
// tareas/notas personales (workforce/tasks exige sucursal+responsable+fecha; las
// notas de leads exigen un lead). Cuando exista, va aquí.

import { Check, Copy, RotateCcw } from 'lucide-react';
import { useCopy } from './clipboard';

export function MessageActions({ text, onRegenerate, pinned = false }: { text: string; onRegenerate?: () => void; pinned?: boolean }) {
  const [copied, copy] = useCopy();
  const btn =
    'inline-flex h-8 items-center gap-1.5 rounded-lg px-2 text-xs font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-50';
  return (
    <div className={`o-msg-actions ${pinned ? 'is-pinned' : ''} -ml-1.5 flex items-center gap-0.5`} role="toolbar" aria-label="Acciones de la respuesta">
      {text && (
        <button type="button" className={btn} onClick={() => copy(text)} title="Copiar respuesta">
          {copied ? <Check size={14} className="text-primary" aria-hidden /> : <Copy size={14} aria-hidden />}
          <span aria-live="polite">{copied ? 'Copiado' : 'Copiar'}</span>
        </button>
      )}
      {onRegenerate && (
        <button type="button" className={btn} onClick={onRegenerate} title="Volver a enviar tu último mensaje">
          <RotateCcw size={14} aria-hidden />
          <span>Regenerar</span>
        </button>
      )}
    </div>
  );
}
